/** Defaults for admin management tables (#716). */
export const dataTableConfig = {
  defaultPageSize: 20,
  pageSizeOptions: [10, 20, 30, 50, 100] as const,
  maxPageSize: 100,
  searchDebounceMs: 300,
  /** Keyboard: focus global search when `/` is pressed outside inputs. */
  searchHotkey: '/',
} as const
